//types used in VERIFY_EMAIL
export const VERIFY_EMAIL_LOADING = "VERIFY_EMAIL_LOADING";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_ERROR = "VERIFY_EMAIL_ERROR";
